import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getProgressCharts, getProgressWeightHistoryList, getProgressMemberWeightHistoryList, postAddWeight } from "../../store/actions";
import { Container, Row, Col, Tab, Tabs } from "react-bootstrap";
import AddWeightModal from "./addWeight";
import ProgressWeightChart from "./progressWeightChart";
import ProgressWeightDetailChart from "./progressWeightDetailChart";
import WeightHistoryTable from "./weightHistoryTable";
import { get } from "lodash";
import "./progress.scss";

function Progress({
	getProgressCharts,
	getProgressWeightHistoryList,
	getProgressMemberWeightHistoryList,
	stackedWeightDetail,
	weightChart,
	weightHistoryList,
	memberweightHistoryList,
	weightChange }) {
	useEffect(() => {
		getProgressCharts();
		getProgressWeightHistoryList("?limit=20");
		getProgressMemberWeightHistoryList("?limit=20");
	}, [getProgressCharts, getProgressWeightHistoryList, getProgressMemberWeightHistoryList]);
	const [showModal, setShowModal] = useState(false);

	return (
		<Container className="progress-main-container">
			<Row className="row-bottom-margin">
				<Col>
					<button
						className="btn btn-primary ml-3 float-right"
						onClick={() => setShowModal(true)}>
						Add Weight
					</button>
				</Col>
			</Row>
			<Row className="row-bottom-margin">
				<Col>
					<ProgressWeightChart weightChart={weightChart} weightChange={weightChange} />
				</Col>
			</Row>
			<Row className="row-bottom-margin">
				<Col>
					<ProgressWeightDetailChart stackedWeightDetails={stackedWeightDetail} />
				</Col>
			</Row>
			<Row className="row-bottom-margin">
				<Col>
					<Tabs>
						<Tab eventKey="weightHistoryTable" title="Weight History Table">
							<WeightHistoryTable getData={getProgressWeightHistoryList} weightHistoryList={weightHistoryList} name={"Weight History Table"}/>
						</Tab>
						<Tab eventKey="memberWeightHistoryTable" title="My Weight Entries">
							<WeightHistoryTable getData={getProgressMemberWeightHistoryList} weightHistoryList={memberweightHistoryList} name={"My Weight Entries"} />
						</Tab>
					</Tabs>
				</Col>
			</Row>
			<AddWeightModal show={showModal} onHide={setShowModal} postAddWeight={postAddWeight} onCreate={() => getProgressMemberWeightHistoryList("?limit=20")} />
		</Container>
	);
}
const mapStateToProps = (state) => {
	const { Progress } = state;
	return {
		weightChange: Progress.weight_change,
		weightChart: Progress.weight_chart,
		weightHistoryList: Progress.weight_history_list,
		memberweightHistoryList: Progress.memberweight_history_list,
		stackedWeightDetail: get(Progress, "stacked_weight_detail[0]", [])
	};
};

const mapDispatchToProps = {
	getProgressCharts,
	getProgressWeightHistoryList,
	getProgressMemberWeightHistoryList,
	postAddWeight
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Progress);
